var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"id":"cursor","dense":"","name":"cursor","label":"cursor","outlined":""},model:{value:(_vm.cursor),callback:function ($$v) {_vm.cursor=$$v},expression:"cursor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }